// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SubjectAreaModel from '../../model/subject-area-model';
import SubjectAreaDTO from '../dto/subject-area-dto';
import dtoSchema from '../schemas/subject-area-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SubjectAreaModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SubjectAreaDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;

  static toModel(dto: DeepPartial<SubjectAreaDTO>): SubjectAreaModel;
  static toModel(dto: DeepPartial<SubjectAreaDTO> | undefined | null): SubjectAreaModel | undefined;
  static toModel(dto: DeepPartial<SubjectAreaDTO> | undefined | null): SubjectAreaModel | undefined {
    return dto ? new SubjectAreaModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SubjectAreaModel> | SubjectAreaModel): SubjectAreaDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
    } as SubjectAreaDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SubjectAreaModel, can not map to SubjectAreaDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
